module.exports = __webpack_public_path__ + "media/application/images/customers/theory-house-2080952cf39110e164396d24a77f3886.jpg";